import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Lead } from 'src/app/models/lead-model';
import { apiUrls } from 'src/app/utils/apiUrls';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  private filterState = new BehaviorSubject<any>({
    accountType: '',
    addedBy: '',
    companyName: '',
    leadState: '',
    country: '',
    state: '',
    city: '',
    page: 0,
    size: 10,
    contains: ''
  });

  filterState$ = this.filterState.asObservable();
  private readonly SEARCH_STATE_KEY = 'leadSearchState';

  ONBOARDING_BASE_URL = environment.ONBOARDING_BASE_URL;

  updateFilterState(newState: any) {
    this.filterState.next({ ...this.filterState.value, ...newState });
  }

  getFilterState() {
    return this.filterState.value;
  }

  clearFilterState() {
    this.filterState.next({
      accountType: '',
      addedBy: '',
      companyName: '',
      leadState: '',
      country: '',
      state: '',
      city: '',
      page: 0,
      size: 10,
      contains: ''
    });
  }
  constructor(private http: HttpClient) { }

  public addLead(leadData: any): Observable<any> {
    return this.http.post<any>(apiUrls.salesLeads, leadData);
  }
  public getLeadSummary(): Observable<any> {
    return this.http.get<any>(apiUrls.leadSummary);
  }
  public getLeadSummaryWithFiltersAndContains(leadFilters: any, contains: string): Observable<any> {
    return this.http.post<any>(this.ONBOARDING_BASE_URL+`/leads/summary-filters-contains?contains=${contains}`, leadFilters);
  }

  public updateLead(leadData: any): Observable<any> {
    return this.http.put(apiUrls.salesLeads, leadData);
  }

  public getPrimaryCategory(): Observable<any> {
    return this.http.get<any>(apiUrls.primaryCategory);
  }
  public  createAccount(leadId: string):Observable<any> {
    return this.http.get<any>(apiUrls.createAccount + leadId);
  }

  public getSecondaryCategory(): Observable<any> {
    return this.http.get<any>(apiUrls.secondaryCategory);
  }

  public getTertiaryCategory(): Observable<any> {
    return this.http.get<any>(apiUrls.tertiaryCategory);
  }

  public getLeadById(leadId: string): Observable<any> {
    return this.http.get<any>(apiUrls.salesLeadss + leadId);
  }

  public getProductRange(): Observable<any> {
    return this.http.get<any>(apiUrls.productRange);
  }

  public getLeads(): Observable<Lead[]> {
    return this.http.get<Lead[]>(apiUrls.salesLeads).pipe(map((res: any) =>  res?.data));
  }
  public sendTableLeads(leadData:any,page?: number, size?: number,contains?: string): Observable<any> {
    const params = new HttpParams()
      .set('page', page? page.toString() : '0')
      .set('size', size ? size.toString(): '10')
      .set('contains', contains ? contains.toString() : '');
      return this.http.post<any>(apiUrls.salesTableLeads, leadData, { params });
  }

  public getLead(leadId: string): Observable<Lead[]> {
    return this.http.get<Lead[]>(apiUrls.salesLeadss + leadId).pipe(map((res: any) =>  res?.data));
  }

  public deleteLead(leadId: string): Observable<any> {
    return this.http.delete(apiUrls.salesLeadss + leadId);
  }
  saveSearchState(searchQuery: string): void {
    localStorage.setItem(this.SEARCH_STATE_KEY, searchQuery);
  }

  getSearchState(): string | null {
    return localStorage.getItem(this.SEARCH_STATE_KEY);
  }

  clearSearchState(): void {
    localStorage.removeItem(this.SEARCH_STATE_KEY);
  }
}